import styled, { css } from 'styled-components';
import { fontSize } from 'app/shared/styles/_fontsize';
import { padding, stacked } from 'app/shared/styles/_spacing';
import { colors } from 'app/shared/styles/_colors';

interface ArticleContainerProps {
  fluid?: boolean;
  background?: 'backgroundWhite' | 'backgroundGrey';
  border?: 'borderTop' | 'borderBottom';
}

export const ArticleContainer = styled.article<ArticleContainerProps>`
  &:not(:last-of-type) {
    ${stacked._3x};
  }

  &:last-of-type {
    padding-bottom: 40px;
  }

  ${(props) =>
    props.fluid &&
    css`
      padding-top: 40px;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
      position: relative;
      left: -16px;
      width: calc(100% + 32px);
    `}

  ${(props) =>
    props.background === 'backgroundWhite' &&
    css`
      background: ${colors['$hpx-white']};
    `}

    ${(props) =>
    props.background === 'backgroundGrey' &&
    css`
      background: ${colors['$hpx-grey-100']};
    `}

    ${(props) =>
    props.border === 'borderTop' &&
    css`
      border-top: 1px solid ${colors['$hpx-grey-500']};
    `}

    ${(props) =>
    props.border === 'borderBottom' &&
    css`
      border-bottom: 1px solid ${colors['$hpx-grey-500']};
    `}
`;

export const Header = styled.header`
  ${padding.top._1x};
  ${padding.bottom._1x}
`;

export const Title = styled.h2`
  color: ${colors['$hpx-grey-600']};
  font-size: ${fontSize['$font-size-lg']};
  line-height: ${fontSize['$line-height-lg']};
`;
